import { forwardRef } from 'react';

export type HeaderContentPosition = 'left' | 'center' | 'right';
export type HeaderContentAlign = 'start' | 'center' | 'end';

export interface HeaderContentProps extends React.HTMLAttributes<HTMLDivElement> {
  position: HeaderContentPosition;
  align?: HeaderContentAlign;
  children: React.ReactNode;
  priority?: number; // For flex grow priority
}

const HeaderContent = forwardRef<HTMLDivElement, HeaderContentProps>(({
  position,
  align = 'center',
  children,
  priority = 0,
  className = '',
  ...props
}, ref) => {
  const getContentClasses = () => {
    const baseClasses = ['flex'];

    // Alignment classes
    const alignClasses = {
      start: ['items-start'],
      center: ['items-center'],
      end: ['items-end']
    };

    // Position classes
    const positionClasses = {
      left: ['justify-start'],
      center: ['justify-center', 'flex-1'],
      right: ['justify-end']
    };

    // Priority classes (flex grow)
    const priorityClasses = priority > 0 ? [`flex-${priority}`] : [];

    return [
      ...baseClasses,
      ...alignClasses[align],
      ...positionClasses[position],
      ...priorityClasses,
      className
    ].filter(Boolean).join(' ');
  };

  return (
    <div
      ref={ref}
      className={getContentClasses()}
      {...props}
    >
      {children}
    </div>
  );
});

HeaderContent.displayName = 'HeaderContent';

export default HeaderContent;